import React, { useRef } from "react";
import { Play, ChevronLeft, ChevronRight } from "lucide-react";
import { media, translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import VideoDialog from "./VideoDialog";
import useReveal from "../hooks/useReveal";

export default function Testimonials() {
  const [active, setActive] = React.useState(null);
  const { ref, visible } = useReveal();
  const trackRef = useRef(null);
  const { lang } = useLang();
  const t = translations[lang].testimonials;

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * Math.max(el.clientWidth * 0.8, 320), behavior: "smooth" });
  };

  return (
    <section className="py-24 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex items-end justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-sm font-bold uppercase tracking-widest text-cblue">{t.eyebrow}</span>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-extrabold text-navy leading-tight">{t.title}</h2>
            <p className="mt-4 text-slate-600">{t.subtitle}</p>
          </div>
          <div className="hidden sm:flex items-center gap-3 shrink-0">
            <button onClick={() => scrollBy(-1)} aria-label="Previous" className="grid h-12 w-12 place-items-center rounded-full border border-slate-200 bg-white text-navy hover:border-cblue hover:text-cblue transition-colors"><ChevronLeft className="h-6 w-6" /></button>
            <button onClick={() => scrollBy(1)} aria-label="Next" className="grid h-12 w-12 place-items-center rounded-full border border-slate-200 bg-white text-navy hover:border-cblue hover:text-cblue transition-colors"><ChevronRight className="h-6 w-6" /></button>
          </div>
        </div>
        <div ref={(node) => { ref.current = node; trackRef.current = node; }}
          className={`mt-12 flex gap-6 overflow-x-auto snap-x snap-mandatory pb-4 -mx-1 px-1 reveal ${visible ? "is-visible" : ""}`}
          style={{ scrollbarWidth: "none" }}>
          {media.testimonials.map((item, idx) => (
            <div key={idx} className="snap-start shrink-0 w-[280px] rounded-3xl bg-white shadow-sm border border-slate-100 overflow-hidden">
              <button onClick={() => setActive(item)} className="group relative block w-full focus:outline-none" aria-label="Play video">
                {item.poster ? (
                  <img src={item.poster} alt="" className="w-full h-80 object-cover object-top" />
                ) : (
                  <video src={`${item.videoUrl}#t=0.5`} muted playsInline preload="metadata" className="w-full h-80 object-cover bg-slate-900" />
                )}
                <span className="absolute inset-0 bg-navy/25 transition-colors group-hover:bg-navy/40" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="grid h-14 w-14 place-items-center rounded-full bg-white/95 shadow-lg transition-transform duration-300 group-hover:scale-110"><Play className="h-6 w-6 text-navy fill-navy ml-0.5" /></span>
                </span>
              </button>
              {item.caption ? (<div className="p-5"><p className="text-sm text-slate-600 leading-relaxed">{item.caption}</p></div>) : null}
            </div>
          ))}
        </div>
      </div>
      <VideoDialog videoUrl={active?.videoUrl} open={!!active} onOpenChange={(o) => !o && setActive(null)} />
    </section>
  );
}
